import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'store/redux.store'
import BlipChatMicroFrontend from 'BlipChatMicroFrontend/App'

import Cookies from 'js-cookie'
import { COOKIE_INTEGRATION_NAME, LOCALSTORAGE_TOKEN_NAME } from 'modules/auth/auth.constants'
import { getUser } from 'modules/user'
import { getContext } from 'modules/context'
import { authService } from 'modules/auth'

const BlipChatComponent = (): JSX.Element => {
  const { auth, user } = useSelector(state => state)
  const dispatch = useDispatch()
  const localToken = localStorage.getItem(LOCALSTORAGE_TOKEN_NAME)
  const cookieTobeUsedAsValue = Cookies.get(COOKIE_INTEGRATION_NAME)

  const chatDomain = 'VULCANO'
  const isEnabled = true

  useEffect(() => {
    if (cookieTobeUsedAsValue && localToken) {
      return
    }

    authService.login()
  }, [])

  useEffect(() => {
    if ((auth || (localToken && cookieTobeUsedAsValue)) && !user) {
      Promise.resolve(dispatch(getUser())).then(() => dispatch(getContext()))
    }
  }, [auth, user])

  const props = {
    token: auth?.hmVlcIntegration || localStorage.getItem('token'),
    language: user?.language ?? '',
    userId: user?.id,
    email: user?.email,
    name: user?.name,
    entityType: user?.profile?.entityType,
    domain: chatDomain,
    isEnabled
  }

  return (
    <>
      <BlipChatMicroFrontend {...props} />
    </>
  )
}

export default BlipChatComponent
